/**
 * Created by Ivan on 06.08.2025
 */

const PersonalBest = function () {
    this.data = {};

    this.load();

    connector.metrics.on("updateTimeIncrement", this.onActiveTimeIncrement.bind(this));
    connector.metrics.on("startDay", this.onStartDay.bind(this));
};

PersonalBest.prototype.load = function () {
    this.data = cleverapps.dataLoader.load(DataLoader.TYPES.PERSONAL_BEST) || {};

    Object.values(this.data).forEach((values) => {
        values.forEach((entry) => {
            entry.value = parseInt(entry.value) || 0;

            if (entry.value > 49293408312494000) {
                entry.value -= 49293408312494000;
            }
        });
    });
};

PersonalBest.prototype.getData = function () {
    return this.data;
};

PersonalBest.prototype.save = function () {
    cleverapps.dataLoader.save(DataLoader.TYPES.PERSONAL_BEST, this.getData());
};

PersonalBest.prototype.onStartDay = function () {
    const day = Math.floor(Date.now() / PersonalBest.MS_IN_DAY);

    for (const event in this.data) {
        this.data[event] = this.data[event].filter((entry) => (day - entry.event) < PersonalBest.PERIOD);
        if (this.data[event].length === 0) {
            delete this.data[event];
        }
    }

    this.save();

    for (const event in this.data) {
        if (event !== "active_time") {
            this.report(event);
        }
    }
};

PersonalBest.prototype.onActiveTimeIncrement = function () {
    this.addPoint("active_time", 1);
};

PersonalBest.prototype.addPoint = function (event, value) {
    if (typeof value !== "number" || isNaN(value)) {
        cleverapps.throwAsync(`personal best value is not a number ${typeof value} ${value}`);

        value = parseInt(value);

        if (isNaN(value)) {
            return;
        }
    }

    if (value > 1200 && cleverapps.config.name === "garden") {
        let message = `personal best value is too big ${value}`;
        if (Merge2.current) {
            const orderManager = Merge2.current.orderManager;
            const simpleAlgo = orderManager.simpleAlgorithm;
            const surplus = simpleAlgo.volumeBalancer.surplusEWMA;
            message += `, surplus: ${surplus}`;
        }

        cleverapps.throwAsync(message);
        return;
    }

    const day = Math.floor(Date.now() / PersonalBest.MS_IN_DAY);

    if (!this.data[event]) {
        this.data[event] = [];
    }

    let entry = this.data[event].find((entry) => entry.event === day);
    if (!entry) {
        entry = {
            event: day,
            value: 0,
            count: 0

        };
        this.data[event].push(entry);
    }

    entry.value += value;
    entry.count += 1;

    this.save();
};

PersonalBest.prototype.report = function (event) {
    const perDaySpeed = this.getPerDaySpeed(event);
    cleverapps.playSession.logAvg(`${event}_day`, { value: perDaySpeed });

    const perMinuteSpeed = this.getPerMinutesSpeed(event);
    cleverapps.playSession.logAvg(`${event}_minute`, { value: perMinuteSpeed });
    cleverapps.playSession.logDistribution(`${event}_minute`, perMinuteSpeed, [0.2, 0.4, 0.6, 0.8, 1]);

    const avgStep = this.getAvgStep(event);
    cleverapps.playSession.logAvg(`${event}_avg_step`, { value: avgStep });
};

PersonalBest.prototype.getPerDaySpeed = function (event) {
    const eventValues = this.data[event] || [];
    const activeTimes = this.data["active_time"] || [];
    const eventTotal = eventValues.reduce((sum, r) => sum + r.value, 0);
    const daysEvents = activeTimes.map((item) => item.event);
    const days = Math.max(...daysEvents) - Math.min(...daysEvents) + 1;
    return days > 0 ? eventTotal / days || 0 : 0;
};

PersonalBest.prototype.getPerMinutesSpeed = function (event) {
    const eventValues = this.data[event] || [];
    const activeTimes = this.data["active_time"] || [];
    const eventTotal = eventValues.reduce((sum, r) => sum + r.value, 0);
    const minutes = activeTimes.reduce((sum, r) => sum + r.value, 0);
    return minutes > 0 ? eventTotal / minutes || 0 : 0;
};

PersonalBest.prototype.getAvgStep = function (event) {
    const eventValues = this.data[event] || [];
    const totalValue = eventValues.reduce((sum, r) => sum + (r.count ? r.value : 0), 0);
    const totalCount = eventValues.reduce((sum, r) => sum + (r.count || 0), 0);

    return totalCount > 0 ? Math.round(totalValue / totalCount) || 0 : 0;
};

PersonalBest.prototype.getDefaultAvgStep = function (event) {
    const data = PersonalBest.DEFAULT_STEP[event];
    if (data) {
        return data[cleverapps.config.type] || data.default;
    }
};

PersonalBest.prototype.getDefaultPerDaySpeed = function (event) {
    const data = PersonalBest.DEFAULT_PER_DAY_SPEED[event];

    if (data && data[cleverapps.config.type]) {
        return data[cleverapps.config.type];
    }

    cleverapps.throwAsync(`value not set for PersonalBest type ${cleverapps.config.type} by day ${event}`);
    return data ? data.default : 0;
};

PersonalBest.prototype.getDefaultPerMinuteSpeed = function (event) {
    const data = PersonalBest.DEFAULT_PER_MINUTE_SPEED[event];
    if (data && data[cleverapps.config.type]) {
        return data[cleverapps.config.type];
    }

    cleverapps.throwAsync(`value not set for PersonalBest type ${cleverapps.config.type} by minute ${event}`);
    return data ? data.default : 0;
};

PersonalBest.PERIOD = 30; // days
PersonalBest.MS_IN_DAY = 24 * 60 * 60 * 1000;

PersonalBest.DEFAULT_STEP = {
    kingscup: {
        default: 20,
        merge: 5,
        merge2: 10,
        match3: 1,
        board: 1
    },
    spacerace: {
        default: 1
    },
    royal_league: {
        default: 5
    }
};

PersonalBest.DEFAULT_PER_DAY_SPEED = { // get and update it from statistic https://redash.cleverappssg.com/dashboard/active-time-orders---source-data?p_date=d_this_month&p_project=garden&p_source=%25
    kingscup: {
        default: 5,
        merge2: 400,
        merge: 350,
        board: 60,
        match3: 30
    },
    spacerace: {
        default: 100
    },
    lightning: {
        default: 10
    },
    royal_league: {
        default: 30,
        match3: 30,
        solitaire: 30
    }
};

PersonalBest.DEFAULT_PER_MINUTE_SPEED = { // get and update it from statistic https://redash.cleverappssg.com/dashboard/active-time-orders---source-data?p_date=d_this_month&p_project=garden&p_source=%25
    spacerace: {
        merge2: 0.37
    },

    lightning: {
        merge2: 0.33,
        solitaire: 1,
        tile3: 2,
        board: 2,
        differences: 2,
        match3: 0.5,
        blocks: 2
    }
};
